module.exports = __webpack_public_path__ + "static/media/20481472_cinematic-parallax-slideshow_by_cowardrobertford_preview_1576243035263.063b2beb.mp4";